import * as React from 'react';
import { connect } from 'react-redux';
import ObjectDrawingSettingTabPanel from './ObjectDrawingSettingTabPanel';
import StampSettingTabPanel from './StampSettingTabPanel';
import { AppStates } from '../../../../../..';
import { ShapeKind } from '../../../drawing/types';

interface ObjectDrawingSettingPanelProps {
  shapeKind: ShapeKind;
}

const ObjectDrawingSettingPanel: React.SFC<
  ObjectDrawingSettingPanelProps
> = React.memo((props) => {
  const panel: JSX.Element = (props.shapeKind === ShapeKind.Stamp)
    ? <StampSettingTabPanel />
    : <ObjectDrawingSettingTabPanel />;

  return panel;
});

const mapStateToProps = (appStates: AppStates) => {
  const { selected, toolSettings } = appStates.ui.objectDrawing;
  return { shapeKind: toolSettings[selected].shapeKind };
};

export default connect(mapStateToProps)(ObjectDrawingSettingPanel);
